module.exports = __webpack_public_path__ + "static/media/ic-listview.ec59c974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-listview.svg
// module id = 635
// module chunks = 14